// extracted by mini-css-extract-plugin
export default {"content":"Legal_content__qgn26","container":"Legal_container__7X2kP","header":"Legal_header__P2Pym","logo":"Legal_logo__P7u1O"};